import { useResourceContext } from "@/layouts/ResourceContext";
import { useShow } from "@refinedev/core";
import { Tabs } from "antd";
import { EksSummaryPanel } from "./EksSummary"
import { EksNodeGroupPanel } from "./EksNodeGroup";
import { EventsPanel } from "@/components/instance/panels/Events";
import { ControlPlane } from "@/components/instance/panels/Access";


export const EksDetailTabs = () => {
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedEks] } = state;  
  const { query } = useShow({ 
    resource:"eks",
    "id": selectedEks?.name
  });
  const { data, isLoading } = query;
  if(isLoading) {
    return <div>Loading...</div>
  } else if(!selectedEks) {
    return <div></div>
  }
  const tabs = [
    { key: 'summary', label: 'Summary', children: (<EksSummaryPanel data={data} />) },
    { key: 'nodeGroups', label: 'Node Groups', children: (<EksNodeGroupPanel data={data}/>) },
    { key: "events", label: "Events", children: (<EventsPanel type="eks"/> )},
    { key: "access", label: "Control Plane", children: (<ControlPlane/> )}
  ];
  return (
    <Tabs items={tabs}></Tabs>
  );
}; 